import React from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronRight } from "lucide-react";

const SidebarMenu = ({
  title,
  icon: Icon,
  isActive,
  isOpen,
  toggleSubMenu,
  subMenuItems = [],
  disabled = false,
  color = "#000",
}) => {
  return (
    <li
      className={`menu-item ${disabled ? "disabled" : ""}`}
      onClick={!disabled ? toggleSubMenu : undefined}
      style={{ position: "relative" }}
    >
      <div className="menu-link-wrapper">
        {disabled ? (
          <div className="menu-link disabled-link">
            <ChevronRight
              className={`arrow_right_icon ${isOpen ? "active" : ""}`}
            />
            <Icon color="#999" />
            <span>{title}</span>
            <div className="sidebar_tooltip">Upgrade plan to use this feature</div>
          </div>
        ) : (
          <Link to="#" className={`menu-link ${isActive ? "active" : ""}`}>
            <ChevronRight
              className={`arrow_right_icon ${isOpen ? "active" : ""}`}
            />
            <Icon color={color} />
            <span>{title}</span>
          </Link>
        )}
      </div>

      {/* Submenu */}
      {!disabled && (
        <ul className={`sub-menu ${isOpen ? "open" : ""}`}>
          {subMenuItems.map((item) => (
            <li key={item.to}>
              <Link to={item.to} className={item.isActive ? "active" : ""}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SidebarMenu;
